import React from 'react';
import format from 'string-template';
import { connect } from 'react-redux';
import { omit, isEmpty } from 'lodash';
import { withRouter } from 'react-router';
import { confirmation, length } from 'redux-form-validators';

import { APP_NAME } from '../../../constants';
import { NAME_LENGTH, FIRSTNAME_LENGTH } from '../../../constants/form';

import { registerUser } from '../../../services/authentication/register/actions';

import {
    FormComponent,
    EmailInputFieldComponent,
    PasswordInputFieldComponent,
    TextInputFieldComponent,
    RadioInputFieldComponent,
    CheckboxInputFieldComponent,
    LegendFieldComponent
} from '../../../components/form';
import { SuccessInfoComponent } from '../../form/SuccessInfoComponent';
import { RegisterFormComponentContainer } from './RegisterFormComponentStyle';

const civilities = [
    { label: 'M', value: 'MONSIEUR' },
    { label: 'Mme', value: 'MADAME' }
];
const CONFIRMATIONS_FIELD_NAME = ['emailconfirm', 'passwordconfirm', 'cguacceptance'];

class RegisterFormComponent extends React.Component {
    submit = values => {
        // API does not need confirmations fields
        this.props.registerUser(omit(values, CONFIRMATIONS_FIELD_NAME), () => {
            this.props.history.push('/');
        });
    };

    render() {
        const {
            errorMessage,
            i18n,
            i18nCommon,
            requestSubmit,
            successSubmit,
            errorSubmit
        } = this.props;

        if (!successSubmit) {
            return (
                <RegisterFormComponentContainer>
                    <FormComponent
                        form="register-form"
                        onSubmit={this.submit}
                        requestSubmit={requestSubmit}
                        errorSubmit={errorSubmit}
                        className="register-form"
                        submitText={i18n.BUTTON_REGISTER}>
                        <RadioInputFieldComponent
                            name="civility"
                            label={i18n.CIVILITY}
                            options={civilities}
                            isRequired
                            isInlineLabel
                        />
                        <TextInputFieldComponent
                            name="lastname"
                            placeholder={i18n.LASTNAME}
                            isRequired
                            validate={[
                                length({
                                    max: NAME_LENGTH,
                                    msg: format(
                                        i18nCommon.TEXT_TOOLONG,
                                        NAME_LENGTH,
                                        NAME_LENGTH > 1 ? 's' : ''
                                    )
                                })
                            ]}
                        />
                        <TextInputFieldComponent
                            name="firstname"
                            placeholder={i18n.FIRSTNAME}
                            isRequired
                            validate={[
                                length({
                                    max: FIRSTNAME_LENGTH,
                                    msg: format(
                                        i18nCommon.TEXT_TOOLONG,
                                        FIRSTNAME_LENGTH,
                                        FIRSTNAME_LENGTH > 1 ? 's' : ''
                                    )
                                })
                            ]}
                        />
                        <EmailInputFieldComponent
                            name="email"
                            placeholder={i18n.EMAIL}
                            isRequired
                            validate={[confirmation({ field: 'emailconfirm', msg: ' ' })]}
                        />
                        <EmailInputFieldComponent
                            name="emailconfirm"
                            placeholder={i18n.EMAIL_CONFIRM}
                            isRequired
                            validate={[
                                confirmation({
                                    field: 'email',
                                    msg: i18n.EMAIL_CONFIRM_ERROR
                                })
                            ]}
                        />
                        <PasswordInputFieldComponent
                            name="password"
                            placeholder={i18n.PASSWORD}
                            isRequired
                            validate={[confirmation({ field: 'passwordconfirm', msg: ' ' })]}
                        />
                        <PasswordInputFieldComponent
                            name="passwordconfirm"
                            placeholder={i18n.PASSWORD_CONFIRM}
                            isRequired
                            validate={[
                                confirmation({
                                    field: 'password',
                                    msg: i18n.PASSWORD_CONFIRM_ERROR
                                })
                            ]}
                        />
                        <CheckboxInputFieldComponent
                            name="newsletterSubscribe"
                            options={[{ label: format(i18n.NEWSLETTER_TEXT, APP_NAME), value: 1 }]}
                        />
                        <CheckboxInputFieldComponent
                            name="cguacceptance"
                            options={[{ label: format(i18n.CGU_TEXT, APP_NAME), value: 1 }]}
                            minRequired={1}
                        />
                        {errorMessage && (
                            <LegendFieldComponent classNameInputContainer="color-err">
                                {errorMessage}
                            </LegendFieldComponent>
                        )}
                    </FormComponent>
                </RegisterFormComponentContainer>
            );
        } else {
            return (
                <SuccessInfoComponent>
                    <p>{i18n.REGISTER_SUCCESS}</p>
                </SuccessInfoComponent>
            );
        }
    }
}

// Which props do we want to inject, given the global state?
function mapStateToProps(state) {
    return {
        errorMessage: state.authentication.error,
        requestSubmit: state.authentication.fetching || false,
        successSubmit: state.authentication.isAuthenticated,
        errorSubmit: !isEmpty(state.authentication.error),
        i18n: state.i18n.page.register,
        i18nCommon: state.i18n.feature.form
    };
}

const mapDispatchToProps = {
    registerUser
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RegisterFormComponent));



// WEBPACK FOOTER //
// ./src/components/authentication/register/RegisterFormComponent.js